import React, { Component, PureComponent } from "react";

import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getSentimentColor, getStrokeColor, numberWithCommas, kmFormatter } from "../utils";
import { chartColors } from "../../../../../lib/utils";

class BarChart extends PureComponent {
    state = {};

    chartComponent = React.createRef();

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent.current && this.chartComponent.current.chart.setSize(null, null);
                this.chartComponent.current && this.chartComponent.current.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getPlatformName = (id) => {
        return this.props.allPlatforms && this.props.allPlatforms.find((plt) => plt.id === id).name;
    };

    getPlatformShortName = (id) => {
        return this.props.allPlatforms && this.props.allPlatforms.find((plt) => plt.id === id).short_name;
    };

    options = () => {
        let data = this.props.dataProp[this.props.splineType];
        let cols = [];
        let totData = 0;
        let mediaNames = [];
        let i = 0;

        for (let plt in data) {
            totData = totData + Math.floor(data[plt]);
        }

        for (let pltId in data) {
            i = i + 1;
            if (data[pltId] === 0) continue;

            let name = this.getPlatformName(pltId);
            let shortName = this.getPlatformShortName(pltId);
            cols.push({
                name: name,
                valueY: Math.floor(data[pltId]),
                dataLabels: {
                    inside: false,
                    x: 10,
                },

                data: [
                    {
                        y: Math.floor(data[pltId]),
                        name: name,
                        //percentVal: ((Math.floor(data[pltId]) / totData) * 100).toFixed(2),
                    },
                ],
                //y: Math.floor(data[pltId]),
                color: getStrokeColor(shortName),
            });

            mediaNames.push(this.getPlatformName(pltId));
        }

        cols = cols && cols.sort((a, b) => b.valueY - a.valueY);

        const options = {
            chart: {
                type: "bar",
                spacingLeft: 40,
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: " ",
            },
            credits: {
                enabled: false,
            },

            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                labels: {
                    formatter: function () {
                        return `<span>${kmFormatter(this.value)}</span>`;
                    },
                },
            },

            xAxis: {
                type: "category",
                lineWidth: 1,
            },

            legend: {
                enabled: this.props.showLegendBar,
                width: "20%",
                layout: "vertical",
                align: "right",
                padding: 3,
                // symbolPadding: 25,
                // x: -10,
                // y: 30,
                // backgroundColor: "white",
                // borderWidth: 1,
                // floating: true,
                itemMarginTop: 3,
                itemMarginBottom: 3,
                verticalAlign: "middle",
                labelFormatter: function () {
                    return `<p>${this.name}</p><br/>`;
                },
                /* eslint-disable */
            },

            series: cols,
            plotOptions: {
                series: {
                    pointWidth: 15,
                    stacking: "normal",
                    borderWidth: 0,
                },
                bar: {
                    borderWidth: 0,
                    dataLabels: {
                        inside: false,
                        enabled: this.props.showLabel,
                        style: {
                            color: "#333333",
                            textOutline: "none",
                        },
                        formatter: function () {
                            return `<span>${kmFormatter(this.point.y)}</span>
                            `;
                        },
                    },
                },
            },
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                outside: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                },
                formatter: function () {
                    return `<p>${this.key}:</p> <p><b>${((this.y / totData) * 100).toFixed(1)}%</b> | <b>${numberWithCommas(this.y)}</b>/ 
                    <b>${numberWithCommas(totData)}</b></p>`;
                },
            },
        };
        return options;
    };

    render() {
        return (
            <HighchartsReact
                ref={this.chartComponent}
                highcharts={Highcharts}
                options={this.options()}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default BarChart;
